export default {
  setUnitToQuote(state, unitToQuote) {
    state.unitToQuote = unitToQuote
  },
  addPaymentMethod(state, paymentMethodToAdd) {
    state.paymentMethods.push(paymentMethodToAdd)
  },
}
